"use strict";
/**
 * This defines the message types sent over an RpcChannel.
 *
 * WARNING: Any changes to these must be backward-compatible, since Rpc may be used across
 * different versions of this library. Specifically, enums must not be renumbered, fields renamed,
 * or their types changed. Really, the only reasonable enhancement is adding a new optional field.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var MsgType;
(function (MsgType) {
    // Warning: Do NOT renumber enums (see warning above).
    MsgType[MsgType["RpcCall"] = 1] = "RpcCall";
    MsgType[MsgType["RpcRespData"] = 2] = "RpcRespData";
    MsgType[MsgType["RpcRespErr"] = 3] = "RpcRespErr";
    MsgType[MsgType["Custom"] = 4] = "Custom";
    MsgType[MsgType["Ready"] = 5] = "Ready";
})(MsgType = exports.MsgType || (exports.MsgType = {}));
